@if (product$ | async; as product) {
  <div class="product-details-container__section product-details-container__section--left">
    <div class="product-details-container__subsection product-details-container__subsection--top">
      <app-uig-product-summary></app-uig-product-summary>
      @if (!hasShopViewUserRole) {
        <app-uig-campaign-note></app-uig-campaign-note>
      }
    </div>
    <div class="product-details-container__subsection product-details-container__subsection--bottom">
      <app-uig-product-manufacturer></app-uig-product-manufacturer>
      @if (product.dropShipmentExcluded) {
        <div>
          <img src="assets/images/availability/dropShipmentExcluded.png"
            title="{{ 'product.dropShipmentExcluded'  | cxTranslate }}" />
            <span
            class="product-dropshipment__label">{{ 'product.dropShipmentExcluded' | cxTranslate  }}</span>
          </div>
        }
        @if (product.bulkyGoods) {
          <div>
            <img src="assets/images/availability/bulkyGoods.png"
              title="{{ 'product.deliveryCostBulkyDirect'  | cxTranslate : getTranslateOptions(product) }}" />
              <span class="product-dropshipment__label">
                {{ 'product.deliveryCostBulkyDirect' | cxTranslate : getTranslateOptions(product) }}
              </span>
            </div>
          }
          <app-uig-availability [product]="product"></app-uig-availability>
        </div>
      </div>
    }
    <div class="product-details-container__section">
      <app-uig-product-prices></app-uig-product-prices>
      @if (!hasShopViewUserRole) {
        <app-uig-product-price-calculator></app-uig-product-price-calculator>
      }
    </div>
